import React from 'react';

/**
 * Client Portal Footer component with LSAS branding
 * @returns {React.ReactElement} ClientFooter component
 */
const ClientFooter = () => {
  return (
    <footer className="bg-brand-black text-ink border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            {/* Logo */}
            <div className="flex justify-center md:justify-start">
              <img 
                src="/assets/logo/logo-lsas-full.svg" 
                alt="Lone Star Aerial Solutions" 
                className="h-20 md:h-24 w-auto opacity-80"
              />
            </div>

            {/* Empty middle section */}
            <div className="text-center">
              {/* Removed duplicate contact info - keeping only in right section */}
            </div>

            {/* Security Notice */}
            <div className="text-center md:text-right">
              <div className="inline-flex items-center px-3 py-2 bg-brand-blue-600/20 rounded-lg">
                <span className="mr-2">🔒</span>
                <div className="text-left">
                  <p className="text-xs font-medium text-brand-blue-600">Secure Portal</p>
                  <p className="text-xs text-ink/80">Enterprise-grade security</p>
                </div>
              </div>
              <div>
                <h3 className="text-sm font-semibold text-white mb-3">Contact Support</h3>
                <div className="space-y-2 text-sm text-ink/80">
                  <p>📧 <a href="mailto:info@lonestaraerialsolutions.com" className="hover:text-white transition-colors">info@lonestaraerialsolutions.com</a></p>
                  <p>📞 <a href="tel:737-777-8044" className="hover:text-white transition-colors">(737) 777-8044</a></p>
                  <p>🌐 <a href="/" className="hover:text-white transition-colors">lonestaraerialsolutions.com</a></p>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-white/10 mt-8 pt-6 text-center">
            <p className="text-sm text-ink/60">
              &copy; {new Date().getFullYear()} Lone Star Aerial Solutions. All rights reserved.
            </p>
            <p className="text-xs text-ink/40 mt-1">
              Secure client portal - All downloads are logged and monitored
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default ClientFooter;
